import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gForm from "@/components/g-form/g-form.vue";
import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";

const name = 'InfoBasicas'
export default {
  name,

  components: {
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-card': gCard,
    'g-button': gButton
   },

  props: { },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  mounted () {
    this.populaInfosBasicas();
    this.ImagemEmpresa();
  },

  updated () { },


  data () {
    return {
        popupCancelaOrc: false,
        opcoesAmostraReferencia: [],
        categories: [{name: 'Acompanha amostra', key: 'A'}, {name: 'Marketing', key: 'M'}, {name: 'Production', key: 'P'}, {name: 'Research', key: 'R'}],
        selectedCategories: [],
        outrosmateriaisop: false,
        numberRow: 0,
        nomeProduto:'',
        observacoes:'',
        quantidade:null,
        dataCarregamento:null,
        descricaoOutrosMateriais:'',
        infoEntregaProduto:[],
        desativarCampoIncial:false,
        copiaOrcamentoQuantidade: false,
        ehAdicao:true,
        quaisMateriais:'',
        displayModalConfirmacao:false,
        escritobotao: true,
        imagemEmpresa: ''
    }
  },

  validations() {
    let quaisMateriaisValidation
    let observacoesValidation = {}
    let quantidadeValidation
    let dataCarregamentoValidation = {}

    quantidadeValidation = {}
    dataCarregamentoValidation = {}

    quantidadeValidation = {
      required: helpers.withMessage('O campo de Quantidade necessita de um valor', required)
    }

    dataCarregamentoValidation = this.testeDataCarregamento

    if( this.opcoesAmostraReferencia.includes('0') || this.opcoesAmostraReferencia.includes('2') ){  //2 === outrosMaterias
      quaisMateriaisValidation={
        // required: helpers.withMessage('O campo Quais Materiais é obrigatório', required)
      }
    }else{
      quaisMateriaisValidation={}
    }

    return {
      nomeProduto:{
        required: helpers.withMessage('O campo de Nome Produto é obrigatório', required)
      },

       quantidade:quantidadeValidation,
       dataCarregamento:dataCarregamentoValidation,
       quaisMateriais:quaisMateriaisValidation,
       observacoes:observacoesValidation,

    }
  },

  methods: {
    verificarDatasRetroativas(infoEntregaProduto) {

      const dataAtual = new Date(); // Data atual
      dataAtual.setHours(0, 0, 0, 0);

      const verificaSeTemRetroativa = infoEntregaProduto.some(item => {
          const { dataCarregamento } = item;
  
          if (!dataCarregamento) {
            return false;
        }
          // Divide a string em partes (dia, mês, ano) e cria um novo objeto Date
          const [dia, mes, ano] = dataCarregamento.split('/');
          const dataCarregada = new Date(ano, mes - 1, dia); // Mês é zero-indexado
          dataCarregada.setHours(0, 0, 0, 0);

          return dataCarregada < dataAtual;
      });
      return verificaSeTemRetroativa;
    },

    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-novo-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    populaInfosBasicas(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetInfosBasicasProdutoNovo/${this.$route.params.id}`,
      })
        .then((Response) => {
          let infosBasicas = Response.data.data
          if(infosBasicas != null){
            this.produtoSelecionadoId = infosBasicas.produtoId;
            this.nomeProduto = infosBasicas.nomeProduto;
            this.observacoes = infosBasicas.observacao;
            this.desativarCampoIncial = infosBasicas.reorcamento;
            this.copiaOrcamentoQuantidade = infosBasicas.copiaOrcamentoQuantidade;

            if(infosBasicas.amostra)
              this.opcoesAmostraReferencia.push('0')
            if(infosBasicas.amostraEspecificacaoTecnica)
              this.opcoesAmostraReferencia.push('1')
            if(infosBasicas.outros)
              this.opcoesAmostraReferencia.push('2')

            this.descricaoOutrosMateriais = infosBasicas.descricaoOutrosMateriais

            this.quantidade = infosBasicas.dataQuantidadeArray[0].quantidade
            this.dataCarregamento = infosBasicas.dataQuantidadeArray[0].dataCarregamentoFormatada
            if(infosBasicas.dataQuantidadeArray.length > 1) {
              for (let i = 1; i < infosBasicas.dataQuantidadeArray.length; i++) {
                var element = {
                  quantidade: infosBasicas.dataQuantidadeArray[i].quantidade,
                  dataCarregamento: infosBasicas.dataQuantidadeArray[i].dataCarregamentoFormatada
                };
                this.infoEntregaProduto.push(element);
              }

            }
          }
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },
    fecharDialog(){
      this.displayModalConfirmacao=false
    },

    changeCheckboxAmostra(){
      if(this.contemAmostra){
        this.ligarCampoEPopup()
      }
    },

    changeCheckboxOutros(){
      if(this.contemOutros){
        this.ligarCampoEPopup()
      }
    },

    changeCheckboxEspecificacoes(){
      if(!this.contemAmostra){
        this.opcoesAmostraReferencia.unshift('0')
        this.ligarCampoEPopup()
      }
    },

    ligarCampoEPopup(){
      this.outrosmateriaisop = true
      if(!(this.contemAmostra && this.contemOutros)){
        this.displayModalConfirmacao = true
      }
    },

    TemQuantidadesIguais(arr) {
      let occurrences = {};

      return arr.some(function(item) {
        if (occurrences[item.quantidade]) {
          return true; // Quantidade repetida encontrada
        } else {
          occurrences[item.quantidade] = true;
          return false;
        }
      });
    },

    estaOrdenadoCrescente(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        // Convertendo as quantidades para números
        const quantidadeAtual = parseFloat(arr[i].quantidade);
        const proximaQuantidade = parseFloat(arr[i + 1].quantidade);
    
        if (quantidadeAtual > proximaQuantidade) {
          return false;
        }
      }
      return true;
    },

    insertOrcamentoQuantidade() {
      let infoEntregaProduto = JSON.parse(JSON.stringify(this.infoEntregaProduto))
      if(this.quantidade != ''){
        infoEntregaProduto.unshift({
          quantidade: this.quantidade,
          dataCarregamento: this.dataCarregamento
        })
      }

      if(this.verificarDatasRetroativas(infoEntregaProduto) === true && !this.desativarCampoIncial){
        this.$toast.add({ severity: 'error', summary: 'Erro, as datas não podem ser retroativas', life: 3200 });
        this.escritobotao = true
        return
      }


      this.$refs.botaoContinuar.isBusy()
      let orcamentoquantidadeArray = {
        OrcamentoId: this.$route.params.id,
        //OrcamentoProdutoId: this.OrcamentoProdutoId,
        Observacao: this.observacoes,
        NomeProduto: this.nomeProduto,
        DataQuantidadeArray: infoEntregaProduto,
        Amostra: this.contemAmostra,
        AmostraEspecificacaoTecnica: this.contemEspecificacoes,
        Outros: this.contemOutros,
        DescricaoOutrosMateriais: this.descricaoOutrosMateriais,

      }
      
      infoEntregaProduto.forEach((e) => {
        e.quantidade = `${e.quantidade}`
      })

      let EstaOrdenado= this.estaOrdenadoCrescente(orcamentoquantidadeArray.DataQuantidadeArray)

      if(EstaOrdenado == false)
      {
        this.$toast.add({severity:'error', summary: 'As quantidades devem estar ordenadas.', detail:"As quantidades devem estar ordenadas da menor para a maior.", life: 5000})
        this.escritobotao = true
        this.$refs.botaoContinuar.isBusy()
        return
      } 
      let quantidadesIguais= this.TemQuantidadesIguais(orcamentoquantidadeArray.DataQuantidadeArray)

      if(quantidadesIguais == true)
        {
          this.$toast.add({severity:'error', summary: 'Erro.', detail:"Não são permitidas quantidades iguais.", life: 5000})
          this.escritobotao = true
          this.$refs.botaoContinuar.isBusy()
          return
        } 
      else{
        this.axios({
          method: "post",
          url: process.env.VUE_APP_WEB_API + 'OrcamentoProduto/post',
          data: orcamentoquantidadeArray
        })
          .then((response) => {
            this.orcamentoquantidadeId = response.data;
  
            // this.$router.push(`/produto-novo/${this.$route.params.id}/componentes-produto`)
  
            if (this.opcoesAmostraReferencia.includes('1')){
              this.escritobotao = true
              this.$router.push(`/produto-novo/${this.$route.params.id}/caracteristicas-produto`)
            }else{
              this.escritobotao = true
              this.$router.push(`/produto-novo/${this.$route.params.id}/componentes-produto`)
            }
          })
          .catch(() => {
          }).finally(this.$refs.botaoContinuar.isBusy)
          
          ;
      }
    },

    camponumero ($event) { // funcao para campo quantidade aceite apenas numero
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) {
         $event.preventDefault();
      }
   },

    step4 () { 
      if(this.v$.$invalid === true){
        this.v$.$silentErrors.forEach(error => {
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })
      } else {
        this.insertOrcamentoQuantidade()
      }

    },
    naoEstaContidoNoArray(array){
      let result = true
      array.forEach(obj=>{
        if(obj.dataCarregamento === this.dataCarregamento && obj.quantidade === this.quantidade){
          result = false
        }
      })
      return result

    },

    voltarstep2(){
      this.$router.push(`/produto-novo/${this.$route.params.id}/lote-frete`)
    },

    addRow() {

      if((this.infoEntregaProduto.length == 2) || !(this.quantidade) && !(this.dataCarregamento)){
        return
      }
      this.infoEntregaProduto.push({
        quantidade: '',
        dataCarregamento: null
      });
    },

    deleteRow(index) {
      this.infoEntregaProduto.splice(index, 1);
    },
   },

  computed: {

    contemOutros(){
      return this.opcoesAmostraReferencia.includes('2')
    },

    contemAmostra(){
      return this.opcoesAmostraReferencia.includes('0')
    },

    contemEspecificacoes(){
      return this.opcoesAmostraReferencia.includes('1')
    },

    testeDataCarregamento(){
      if(this.observacoes){
        return {}
      }
      return {
        required: helpers.withMessage('O campo de Data de Carregamento ou o campo de Observações necessita de um valor', required)
      }
    },

  },

};